<template>
  <v-card>
    <v-toolbar color="primary" dark>
      <v-btn icon @click="$emit('close')">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title>Lista de Frentistas do Posto</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        width="400"
        :fullscreen="$vuetify.breakpoint.xs"
      >
        <v-btn icon slot="activator">
          <v-icon>add</v-icon>
        </v-btn>
        <cad-frentista
          :posto="posto"
          @complete="frentistaSalvo"
        ></cad-frentista>
      </v-dialog>
    </v-toolbar>
    <v-container grid-list-lg class="pt-4 pb-3">
      <v-data-table
        hide-actions
        :hide-headers="!frentistas || !frentistas.length"
        :items="frentistas"
        :headers="frentistasHeaders"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <h3>
                {{
                  props.item.pessoa ? props.item.pessoa.nome : props.item.nome
                }}
              </h3>
            </td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <div v-on="on">R$ {{ props.item.valor_acumulado }}</div>
                </template>
                <span>Valor acumulado para frentista</span>
              </v-tooltip>
            </td>
            <td>
              <v-tooltip bottom v-if="props.item.programa_incentivo">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                    @click="
                      (frentistaSelecionado = props.item),
                        (dialogRetirada = true)
                    "
                    :disabled="props.item.solicitacao_retirada.aberto"
                  >
                    <v-icon color="info">{{
                      props.item.solicitacao_retirada.aberto
                        ? "money_off"
                        : "attach_money"
                    }}</v-icon>
                  </v-btn>
                </template>
                <span>{{
                  props.item.solicitacao_retirada.aberto
                    ? "Você já solicitou retirada"
                    : "Solicite retirada"
                }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                    @click="
                      (frentistaSelecionado = props.item),
                        (dialogCadProgIncentivo = true)
                    "
                  >
                    <v-icon color="info">account_circle</v-icon>
                  </v-btn>
                </template>
                <span>Realizar Cadastro</span>
              </v-tooltip>
            </td>
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                    @click="
                      (frentistaSelecionado = props.item), (dialogSr = true)
                    "
                  >
                    <v-icon color="info">remove_red_eye</v-icon>
                  </v-btn>
                </template>
                <span>Vizualizar Solicitações</span>
              </v-tooltip>
            </td>
            <td class="text-xs-right" style="width: 50px">
              <v-btn icon flat color="info" @click="openDialog(props.item)">
                <v-icon>history</v-icon>
              </v-btn>
            </td>
            <td class="text-xs-right" style="width: 50px">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    flat
                    color="info"
                    @click="openDialogCadPin(props.item)"
                  >
                    <v-icon>fiber_pin</v-icon>
                  </v-btn>
                </template>
                Cadastrar PIN
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-navigation-drawer v-model="history" fixed right temporary width="320">
        <v-list class="pa-1">
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Vouchers lidos</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list three-line class="pt-0">
          <template v-for="(voucher, index) in historyVouchers.results">
            <v-divider
              v-if="index > 0"
              :key="voucher.id_voucher"
              inset
            ></v-divider>
            <v-menu
              offset-x
              :key="voucher.numero"
              left
              transition="slide-x-reverse-transition"
            >
              <template v-slot:activator="{ on }">
                <v-list-tile
                  style="height: 140px"
                  :class="{
                    'grey lighten-3': !voucher.abastecido,
                    opaco: voucher.abastecido,
                  }"
                  :style="{
                    border: voucher.cupom_inserido ? '' : 'solid 2px red',
                  }"
                  avatar
                >
                  <v-list-tile-action
                    v-on="on"
                    class="mt-4"
                    style="height: 135px"
                  >
                    <v-tooltip :color="voucher.combustivel.color" top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <svg-filler
                            :path="
                              voucher.combustivel.icone
                                ? require(`@/assets/combs/${voucher.combustivel.icone}.svg`)
                                : require(`@/assets/combs/gas.svg`)
                            "
                            width="40px"
                            height="40px"
                            :fill="voucher.combustivel.color"
                          />
                        </span>
                      </template>
                      <span>{{ voucher.combustivel.nome }}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                  <v-list-tile-content style="height: 135px; margin-top: 45px">
                    <v-list-tile-title>
                      <template v-if="!voucher.cashposto"
                        >{{ voucher.quantidade_litros }}
                        {{ voucher.descricao_volume || "litros" }} - </template
                      >{{
                        voucher.valor | currency({ fractionCount: 2 })
                      }}</v-list-tile-title
                    >
                    <v-list-tile-sub-title
                      >{{ voucher.hora_inativado.substring(0, 5) }} -
                      {{
                        voucher.data_inativado.split("-").reverse().join("/")
                      }}</v-list-tile-sub-title
                    >
                    <v-list-tile-sub-title
                      >Lido por:
                      {{
                        voucher.frentista.pessoa
                          ? voucher.frentista.pessoa.nome
                          : voucher.frentista.nome
                      }}</v-list-tile-sub-title
                    >
                    <v-list-tile-sub-title
                      class="grey--text text--darken-3 caption font-weight-medium"
                      v-if="!voucher.em_especie"
                    >
                      NSU: {{ voucher.nsu }}
                      <v-tooltip
                        :color="color ? color : voucher.combustivel.color"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            flat
                            icon
                            @click="copyNsu(voucher.nsu)"
                          >
                            <v-icon size="15">content_copy</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ texto }}</span>
                      </v-tooltip>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title
                      class="grey--text text--darken-3 caption font-weight-medium"
                      v-else
                      v-text="
                        voucher.tipo_pagamento
                          ? voucher.tipo_pagamento.toUpperCase()
                          : 'EM ESPÉCIE'
                      "
                    ></v-list-tile-sub-title>
                    <v-list-tile-sub-title
                      v-if="voucher.veiculo"
                      class="grey--text text--darken-3 caption font-weight-medium"
                      >Placa:
                      {{ voucher.veiculo.identificacao }}</v-list-tile-sub-title
                    >
                    <v-list-tile-sub-title
                      v-if="voucher.desconto"
                      class="grey--text text--darken-3 caption font-weight-medium"
                      >Desconto:
                      {{ formatarDesconto(voucher.desconto) }}</v-list-tile-sub-title
                    >
                    <v-list-tile-sub-title
                      class="grey--text text--darken-3 caption font-weight-medium"
                    >
                      Abastecimento:
                      <span
                        :style="{ color: voucher.abastecido ? 'green' : 'red' }"
                        >{{
                          voucher.abastecido ? "Aprovado" : "Pendente"
                        }}</span
                      >
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-layout column align-center justify-end fill-height>
                      <v-tooltip top lazy>
                        <span v-if="voucher.cliente">{{
                          voucher.cliente.nome
                        }}</span>
                      </v-tooltip>
                      <v-flex
                        class="grey--text text--darken-4 caption font-weight-medium"
                        shrink
                        >CPF</v-flex
                      >
                      <v-flex
                        v-if="voucher.cliente"
                        class="grey--text text--darken-4 caption font-weight-medium"
                        shrink
                        v-text="voucher.cliente.nome"
                      ></v-flex>
                    </v-layout>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-menu>
          </template>
        </v-list>
        <div class="text-xs-center">
          <v-pagination
            v-model="pagination.page"
            :length="pages"
            circle
          ></v-pagination>
        </div>
      </v-navigation-drawer>
    </v-container>
    <v-dialog v-model="dialogCadPin" persistent max-width="360">
      <cad-pin
        v-if="dialogCadPin"
        :frentistaSelecionado="frentistaSelecionado"
        :cadPin="cadPin"
        @fechar="dialogCadPin = false"
      />
    </v-dialog>
    <v-dialog v-model="dialogCadProgIncentivo" max-width="600">
      <cad-programa-incentivo
        v-if="dialogCadProgIncentivo"
        :frentistaSelecionado="frentistaSelecionado"
        @fechar="
          (dialogCadProgIncentivo = false),
            (frentistaSelecionado = null),
            carregarFrentistas
        "
      />
    </v-dialog>
    <v-dialog v-model="dialogRetirada" max-width="600">
      <retirada
        v-if="dialogRetirada"
        :frentistaSelecionado="frentistaSelecionado"
        @fechar="
          (dialogRetirada = false),
            (frentistaSelecionado = null),
            carregarFrentistas
        "
      />
    </v-dialog>
    <v-dialog v-if="dialogSr" v-model="dialogSr" max-width="500">
      <solicitacoes-recebimento
        :frentista="frentistaSelecionado"
        :cnpj="frentista.posto.cnpj"
        @fechar="(dialogSr = false), (frentistaSelecionado = null)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import CadFrentista from '@/components/dialogs/CadFrentista'
import CadPin from '@/components/dialogs/CadPin'
import CadProgramaIncentivo from '@/components/dialogs/CadProgramaIncentivo'
import Retirada from '@/components/dialogs/DialogSolicitacaoRetirada'
import SolicitacoesRecebimento from '@/components/dialogs/SolicitacoesRecebimento'

export default {
  components: {
    CadFrentista,
    CadPin,
    CadProgramaIncentivo,
    Retirada,
    SolicitacoesRecebimento
  },
  data () {
    return {
      dialogRetirada: false,
      dialogCadProgIncentivo: false,
      dialogSr: false,
      texto: 'Copiar NSU',
      color: '',
      cadPin: false,
      dialogCadPin: false,
      frentistaSelecionado: null,
      dialogHistoricoCaixa: false,
      dialog: false,
      history: false,
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      frentistasHeaders: [
        {
          text: 'Nome',
          align: 'left',
          sortable: false,
          value: 'nome'
        },
        {
          text: 'Valor Acumulado',
          align: 'left',
          sortable: false,
          value: 'Valor Acumulado'
        },
        {
          align: 'right',
          sortable: false
        },
        {
          align: 'right',
          sortable: false
        },
        {
          align: 'right',
          sortable: false
        },
        {
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    frentistas () {
      return this.$store.getters.frentistas
    },
    frentista () {
      return this.$store.getters.frentista
    },
    historyVouchers () {
      return this.$store.getters.historyVouchers
    },
    pages () {
      let count = this.historyVouchers.count
      if (this.pagination.rowsPerPage == null || count == null) return 0
      return Math.ceil(count / this.pagination.rowsPerPage)
    }
  },
  mounted () {
    this.carregarFrentistas()
  },
  watch: {
    'pagination.page': {
      handler (val, oldval) {
        this.carregarHistoryVouchers()
      },
      deep: true
    }
  },
  methods: {
    formatarDesconto (desconto) {
      if (!desconto) return '0%'
      else if (desconto % 1 !== 0) {
        return `R$ ${desconto.toFixed(2).replace('.', ',')}`
      }
      return `${desconto}%`
    },
    fecharDialogFrentista () {
      this.dialog = false
    },
    frentistaSalvo () {
      this.carregarFrentistas()
      this.fecharDialogFrentista()
    },
    maskedCPF (cpf) {
      let newCpf = `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, 3)}-${cpf.substr(9, 2)}`
      return newCpf
    },
    carregarFrentistas () {
      this.$store.dispatch('listarFrentistas')
    },
    carregarHistoryVouchers () {
      const data = {
        page: this.pagination.page,
        id_frentista: this.frentistaSelecionado.id_frentista
      }
      this.$store.dispatch('carregarHistoryVouchers', data)
    },
    openDialog (frentista) {
      this.frentistaSelecionado = frentista
      this.pagination = { rowsPerPage: 5, page: 1 }
      this.carregarHistoryVouchers()
      this.history = true
    },
    openDialogCadPin (frentista) {
      this.frentistaSelecionado = frentista
      this.cadPin = true
      this.dialogCadPin = true
    },
    copyNsu (nsu) {
      navigator.clipboard.writeText(nsu)
      alert('Copiado')
      this.texto = 'Copiado'
      this.color = 'green'
      let interval = setInterval(() => {
        this.texto = 'Copiar NSU'
        this.color = ''
        clearInterval(interval)
      }, 500)
    }
  }
}
</script>
